function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useCallback } from "react";
import { SelectableWrapper } from "sprout-ui-dom/dist/Selectables";
import { visuallyHiddenStyle } from "sprout-ui-dom/dist/utils";
import { Done, RemoveOutlined } from "sprout-ui-icons";
import { Flex, Text } from "sprout-ui-primitives";
import styled from "styled-components";
import Avatar from "../../Avatar";
const AssignmentDialogUserLabel = styled(Flex)`
  cursor: pointer;
`;
const AssignmentDialogUser = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { user: { user , state  } , onUserChange  } = props, rest = _objectWithoutProperties(props, [
        "user",
        "onUserChange"
    ]);
    const { id , fullName  } = user;
    const labelId = `label-${id}`;
    /**
   * The event handler must be a click event handler, so it must be tied to
   * label element. Having an `onChange` handler on the `input` will not work
   * with `downshift`.
   *
   * This is because the `SelectableWrapper` has an `onClick` handler provided
   * by `downshift`.
   */ const handleChange = useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        onUserChange(props.user, false);
    }, [
        onUserChange,
        props.user
    ]);
    return /*#__PURE__*/ _jsxs(SelectableWrapper, _objectSpread({}, rest, {
        ref: ref,
        children: [
            /*#__PURE__*/ _jsx(AssignmentDialogUserLabel, {
                onClick: handleChange,
                htmlFor: labelId,
                as: "label",
                width: "48px",
                height: "40px",
                ml: -1,
                pr: 1,
                children: /*#__PURE__*/ _jsxs(Flex, {
                    alignItems: "center",
                    justifyContent: "center",
                    m: "auto",
                    borderRadius: "50%",
                    width: "24px",
                    height: "24px",
                    borderWidth: "1px",
                    borderStyle: "solid",
                    borderColor: state === "complete" ? "white.100" : "white.40",
                    bg: state === "complete" ? "white.100" : undefined,
                    color: state === "complete" ? "blue.500" : undefined,
                    children: [
                        /*#__PURE__*/ _jsx("input", {
                            type: "checkbox",
                            style: visuallyHiddenStyle,
                            id: labelId
                        }),
                        state === "indeterminate" && /*#__PURE__*/ _jsx(RemoveOutlined, {}),
                        state === "complete" && /*#__PURE__*/ _jsx(Done, {})
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(Flex, {
                alignItems: "center",
                children: [
                    /*#__PURE__*/ _jsx(Avatar, {
                        size: 32,
                        user: user
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        truncate: true,
                        fontSize: "15px",
                        ml: 2,
                        fontWeight: "medium",
                        children: fullName
                    })
                ]
            })
        ]
    }));
});
export default AssignmentDialogUser;
